import { FORMAT_DURATION_TIME } from '@/utils'

export default FORMAT_DURATION_TIME
